import { render } from "./index.vue?vue&type=template&id=2a0c17a0&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=2a0c17a0&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0c17a0"],['__file',"resources/js/components/whatsapp-managment/includes/Profile/OrderDetails/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a0c17a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a0c17a0', __exports__)) {
    console.log('reload')
    api.reload('2a0c17a0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2a0c17a0&scoped=true", () => {
    console.log('re-render')
    api.rerender('2a0c17a0', render)
  })

}


export default __exports__